import React from "react";
import {comparators, comparatorsField, makeArr, objPathInit, objToArrK, sortKeys} from "../tools/CommonJS";
import HA_types from "analyzer-types/AnalyzerTypes.json";
import {doesSearchIncTpc, severitiesDefs} from "./CommonUIData";
import {isTalDemo} from "./AppContext";
import {Badge} from "../tools/UIBlocks.jsx";

export const HA_topics = HA_types.topics;
export const HA_Remedies = HA_types.remediations;
export const HA_genRemedies = HA_types.genericRemediations;
export const HA_relatedTopics = HA_types.relatedTopics;

export const misconTopicOpts = Object.entries(HA_topics).map(([k, v]) => ({h: v.title, k}));

export function xHA_Repo(code) {
    if (!HA_topics) console.log(HA_types);
    return HA_topics[code] || {
        title: "Unrecognized: "+ code +". Please upgrade the software to the latest version.",
        severity: "Unknown",
        subj: "",
        desc: "",
        sgt: ""
    };
}

export function xHA_Remedies_Repo(action) {
    if (!HA_Remedies) console.log(HA_types);
    return HA_Remedies[action] || {
        title: "Unrecognized: " + action + ". Please upgrade the software to the latest version",
        desc: "",
        topics: [],
        itMinutes: 4
    };
}
// export function HA_GetTopic(code) {
//     return AddKH_Host_Analyzer(xHA_Repo(code).title, code);
// }

export function HA_GetTopic_text(code) {
    return xHA_Repo(code).title;
}

export function getParamTitle(row) {
    const topic = HA_topics[row.topicCode];
    return topic?.paramTitle ?? "Alert";
}

// export function HA_cbSeverityLetter(code, sevIdx) {
//     const rep = xHA_Repo(code?.cellData ?? code);
//     return fmt.cbSeverityLetter(rep.severity, rep.star &&
//         <i className="ml-1 fa fa-star fa-lg text-cyan-500" title="Quick win: recommended to remediate immediately."/>, sevIdx);
// }

export function HA_GetRelOS(code) {
    return xHA_Repo(code).os || ["windows"];
}

export const misconRelatedParamsByTopic = HA_types.relatedParams?.toObj((o, a) =>
    a.forEach(t_p1 => o[t_p1.before(":").trim()] = a.map(t_p2 => ({topicCode: t_p2.before(":").trim(), param: t_p2.after(":").trim() || ""})))) ?? {};

export const hasRelatedParams = (topicCode, param) =>
    misconRelatedParamsByTopic[topicCode]?.some(tp => !param ||
        (tp.topicCode === topicCode && (tp.param === param || (tp.param.endsWith("*") && param.startsWith(tp.param.slice(0, -1))))));

export const misconTopicToRemedyXlat = Object.entries(HA_types.remediations).toObj((o, [actionDatum, r]) =>
    objPathInit(o, [r.topic, []]).push({actionDatum, ...r}));


export const misconTopicFlags = {
        remediated: {h: "Remediated"},
        repeated: {h: "Recurring"},
        alertsNew: {h: "New"},
        pending: {h: "Pending"},
        mutedAlerts: {h: "Muted"},
    }, misconTopicFlagsOpts = objToArrK(misconTopicFlags);

export const misconTopicsFilterDefs = {
        all: {h: "All Attack Vectors", tip: <span>Showing top 5 of <b>all</b> Attack Vectors.</span>, filter: () => true},
        global: {h: "Trending Global", tip: <span>Showing top 5 <b>global threats</b>. Stay tuned with the world's top threats and keep them out of your organization.</span>, filter: tpc => HA_topics[tpc.topicCode]?.global},
        star: {h: "Quick Wins", tip: <span>Showing top 5 <b>Quick Win</b> 'no brainer' remediations.</span>, filter: tpc => HA_topics[tpc.topicCode]?.star},
        aiAgent: {h: "AI Powered", hDisp: <><Badge pill className="bg-purple-500 text-prm-contrast">New</Badge> AI Powered</>, tip: <div>Showing top 5 Attack Vectors related to <Badge pill className="bg-purple-500 text-prm-contrast">New</Badge> <b>AI Powered</b> configurations.</div>, filter: tpc => HA_topics[tpc.topicCode]?.subcategory?.startsWith("AI Powered")},
        pinned: {h: "Pinned", tip: <span>Showing top 5 Attack Vectors that you've <b>pinned</b>.</span>, filter: (tpc, pinned) => pinned.has(tpc.topicCode)},
        ...(isTalDemo && {golden: {h: "Golden Image", tip: <span>Showing top 5 Attack Vectors designated as your <b>Golden Image</b> standard.</span>, filter: (tpc, pinned, golden) => golden.has(tpc.topicCode)}}),
        remediated: {h: "Remediated", tip: <span>Showing top 5 Attack Vectors which have been <b>Remediated</b>.</span>, filter: tpc => tpc.remediated, status: true},
        repeated: {h: "Recurring", tip: <span>Showing top 5 Attack Vectors with threats that <b>reoccurred</b> after a remediation.</span>, filter: tpc => tpc.repeated, status: true},
        alertsNew: {h: "New", tip: <span>Showing top 5 Attack Vectors with <b>new</b> potential threats.</span>, filter: tpc => tpc.alertsNew > 0, status: true},
        mutedAlerts: {h: "Muted", tip: <span>Showing top 5 Attack Vectors with <b>Muted</b> alerts.</span>, filter: tpc => tpc.mutedAlerts > 0, status: true}
    // devices: {h: "Number of Devices", d: "All Attack Vectors sorted by highest number of devices affected.", filter: (tpc, pinned) => true},
    // alerts: {h: "Number of Alerts", d: "All Attack Vectors sorted by highest number of potential threats.", filter: (tpc, pinned) => true, kSort: "alertsBad"},
    }, misconTopicsFilterDefsArr = objToArrK(misconTopicsFilterDefs);

export const misconTopicsSortDefs = {
        sevIdx: {h: "Severity", sort: (aSevIdx, bSevIdx, a, b) => (
            comparators.number(aSevIdx, bSevIdx) ||
            comparators.numberSigRev(a.devicesBad, b.devicesBad) ||
            comparators.stringSig(a.title, b.title))},
        cvss: {h: "CVSS", sort: comparators.numberSigRev},
        title: {h: "Attack Vector", sort: comparators.stringSig},
        devicesAll: {h: "Total Devices", sort: comparators.numberSigRev},
        devicesBad: {h: "Vulnerable Devices", sort: comparators.numberSigRev},
        alertsBad: {h: "Alerts", sort: comparators.numberSigRev},
        alertsNew: {h: "New Alerts", sort: comparators.numberSigRev},
        remediated: {h: "Remediated", sort: comparators.numberSigRev},
        repeated: {h: "Recurring Alerts", sort: comparators.numberSigRev},
        mutedAlerts: {h: "Muted Alerts", sort: comparators.numberSigRev},
    }, misconTopicsSortDefsArr = objToArrK(misconTopicsSortDefs);


// read relatedTopics array (which has arrays of topicCodes), and create for each topic an array of related topics, of superset where this topic appears.
HA_relatedTopics.forEach(relTopics => relTopics.forEach(tp => HA_topics[tp] &&
    (HA_topics[tp].relatedTopics = (HA_topics[tp].relatedTopics || []).concat(relTopics).undup())));


export const descByOs = (genDesc, osObj) => [
    genDesc,
    ...!osObj ? [] : Object.entries(osObj).map(([os, desc]) => desc && `${os}:\n${desc}`)
].filter(Boolean).join("\n\n");


export const miscFilterDefs = {
    Pinned: "pinned",
    "Quick wins": "star",
};

export const getTopicSeverityIdx = tpc =>
    severitiesDefs[tpc.severity || tpc.badge?.capitalizeFirst() || (tpc.alertsBad ? HA_topics[tpc.topicCode]?.severity : "Passed")]?.idx ?? 4;

export const c_allCat = "All";

export function filterMisconCategories({topics, category, severities, sortBy, sortDefs, search, statuses}) {
    let filtered, categoryOpts, severityVals = makeArr(4).map(i => ({k: i, v: 0}));

    if (topics) {
        topics.forEach(tpc => (severityVals[tpc.sevIdx] ?? {}).v += tpc.alerts || 1);
        filtered = topics.filter(tpc => !severities?.length || severities.includes(tpc.sevIdx));

        if (sortDefs)
            filtered.sort(comparatorsField((sortDefs[sortBy] ?? Object.values(sortDefs)[0]).sort, sortBy));

        const curCategories = sortKeys(filtered.groupBy(ent => xHA_Repo(ent.topicCode).subcategory));
        categoryOpts = [c_allCat, ...Object.keys(curCategories || {})].map(cat => ({
            h: cat, k: cat, n: curCategories[cat]?.length || filtered.length
        }));
        if (!curCategories[category]) category = c_allCat;

        if (category !== c_allCat) filtered = curCategories[category];
        if (search) filtered = filtered.filter(tpc => doesSearchIncTpc(HA_topics[tpc.topicCode], search));
        if (statuses?.length)
            filtered = filtered.filter(tpc => statuses.every(flt => misconTopicsFilterDefs[flt]?.filter(tpc)));

    }
    return {filtered, categoryOpts, severityVals};
}
